import React from 'react';
import s from './HeaderSearch.module.css';
import searchIcon from '../../assets/img/Header/ei_search.png';

type Props = {
	actionHref: any;
	textSearch: string;
};
const HeaderSearch: React.FC<Props> = ({actionHref, textSearch}) => {
	return (
		<form action={actionHref} className={s.topHeaderSearchContainer}>
			<div className={s.topHeaderSearch}>
				<label htmlFor="headerInput" className={s.topHeaderSearch_Label}>
					{textSearch}
				</label>
				<div className={s.inputContainer}>
					<input
						id="headerInput"
						name="s"
						type="text"
						className={s.topHeaderSearch_Input}
					/>
					<button type="submit" className="form-top-header__button">
						<img src={searchIcon} alt="find-icon" />
					</button>
				</div>
			</div>
		</form>
	);
};

export default HeaderSearch;
